import { AnalyticsEvent } from '@/types'
const event_category = 'circular_hub'

interface SendEvent {
  action: string
  label: string
  customs?: any
}

export const sendAnalyticEvent = ({
  event_action,
  event_label,
  custom,
}: AnalyticsEvent) => {
  const parameters: AnalyticsEvent = {
    event_category,
    event_action,
    event_label,
  }
  if (custom) {
    parameters.custom = {}
    custom.forEach((aux: any) => {
      if (parameters.custom) {
        parameters.custom[aux.field] = aux.value
      }
    })
  }
  if (window.sendEvent) {
    window.sendEvent(parameters)
  }
}
